YUI.add('directories', function (Y) {

    "use strict";

    var $ = Y.one,
        HOST = "host",
        HOSTNAME_ATTR = "hostname";


    var handleNavigation = function(evt) {

        var target, id;

        target = evt.currentTarget;

        console.log("Nav", this, evt, target);

        id = target.getAttribute("data-ksu-dirid");
        if (!id) {
            return;
        }

        if (evt.altKey && evt.shiftKey && (evt.ctrlKey || evt.metaKey)) {
            window.open(this.get(HOSTNAME_ATTR) + "/directories/staff/edit/" + id + "/", "_blank");
            evt.preventDefault();
            return;
        }

   };


    /* Directory class constructor */
    var Directory = function(config) {
        /* Initialize the plugin infrastructure.  This calls the initializer
         * method on the new instance.
         */
        Directory.superclass.constructor.apply(this, arguments);
    };

    /*
     * Required NAME static field, to identify the class and
     * used as an event prefix, to generate class names etc. (set to the
     * class name in camel case).
     */
    Directory.NAME = "Directory";

    /*
     * Required NS static field, to identify the property on the host which will,
     * be used to refer to the plugin instance ( e.g. host.Directory.doSomething() )
     */
    Directory.NS = "Directory";

    /*
     * The attributes for the plugin.
     */
    Directory.ATTRS = {
        hostname: {
            value: "https://directory.ksucloud.net"
        }
   };


    /* Directory extends the base Plugin.Base class */
    Y.extend(Directory, Y.Plugin.Base, {
        initializer: function(config) {

			var host = this.get(HOST);

            console.log("Initializing", this.name);
            host.delegate("click", handleNavigation, "a", this);
            console.log("initialization complete", this.name);
         }

    });

    Y.namespace("Plugin").Directory = Directory;


}, '2.0.0', {
    "requires": [
        "node",
        "event",
        "plugin"
    ]
});

YUI().use("directories", function(Y) {
    Y.all(".ksu-main-content").plug(Y.Plugin.Directory);
});
